import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { HandoverTimesComponent } from './handover-times.component';

const routes: Routes = [
  { path: '', component: HandoverTimesComponent, data: { title: 'Handover Times' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HandoverTimesRoutingModule {}

@NgModule({
  imports: [
    HandoverTimesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [HandoverTimesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HandoverTimesModule {}
